import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {injectIntl} from 'react-intl';

import SubnavigationContainer from 'containers/ui/layout/nav/SubnavigationContainer';

/** Subnavigation route component for the second level of routes/menu */
class SubnavigationRoute extends Component {

    static propTypes = {
        history: PropTypes.object.isRequired, // The history route object
        routes:  PropTypes.array.isRequired, //The routes to show
        extra:   PropTypes.any // Extra content to show inside subnavigation at rightside
    };

    render() {
        const {routes, extra, history: {location: {pathname}}} = this.props;

        return (
            <SubnavigationContainer
                routes={routes}
                path={pathname}
                extra={extra}
            />
        );
    }
}

export default withRouter(injectIntl(SubnavigationRoute));



// WEBPACK FOOTER //
// ./src/router-with/ui/layout/nav/SubnavigationRoute.jsx